module.exports = __webpack_public_path__ + "media/images/presta_escudo-7bc837b40f12749dfe4666b530a8ffa8.png";